import React from "react";
import { Link } from '@ambiguous/link';
export default function ButtonService({ text, prefetch }) {
    return (React.createElement(React.Fragment, null,
        React.createElement(Link, { href: (prefetch === null || prefetch === void 0 ? void 0 : prefetch.url) || undefined, target: "_blank", rel: "nofollow noreferrer noopener", className: "btn btn-sm btn-outlined btn-primary btn-service" },
            React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" },
                React.createElement("path", { d: "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" }),
                React.createElement("circle", { cx: "12", cy: "7", r: "4" })),
            text)));
}
